module.exports = __webpack_public_path__ + "static/media/kb1.d235eba9.png";